module.exports = __webpack_public_path__ + "img/piaofu-web.88ab97b6.png";